export default __webpack_public_path__ + "static/media/icon-notification.4845ecf0.svg";